import router from '@/V2/router'


export default {
    MyPostToken: function (task) {
        router.push('/carrier/add/MyPost')
    }

}